export default {"src":"/login-app/[GIT_HASH]/_next/static/media/magnify_glass_checked.c0511325.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};